/**
 * Converts a given amount to cents for Stripe.
 *
 * @param {number | string} amount - The amount to convert. Can be a number or a string representing
 *   a number.
 * @returns {number} The amount in cents.
 * @throws {Error} If the amount is not a valid number or string representing a number.
 */
export const convertToStripePrice = (amount) => {
  // Convert amount to cents for Stripe
  if (typeof amount === 'number') {
    return parseInt(Math.round(amount * 100)) // Ensure no decimals
  } else if (typeof amount === 'string') {
    const parsedAmount = parseFloat(amount)
    if (isNaN(parsedAmount)) {
      throw new Error('Invalid amount format')
    }
    return parseInt(Math.round(parsedAmount * 100)) // Ensure no decimals
  }
  throw new Error('Amount must be a number or a string representing a number')
}
